
export function showMessage(type, content, Time = 3000) {
    const iconObj = {
        danger: "ri-error-warning-line",
        success: "ri-check-line",
        warning: "ri-error-warning-line",
        info: "ri-information-line",
    }
    // 显示通用提示信息
    const dom = `<div
    class="alert alert-dismissible alert-solid alert-label-icon fade show position-fixed start-50 translate-middle-x msg-alert alert-${type}"
    role="alert">
    <i class="${iconObj[type]} label - icon"></i>
    ${content} </div>`
    const id = new Date().getTime()
    const newContent = document.createElement("div");
    newContent.classList.add(`my-message${id}`)
    newContent.innerHTML = dom;
    document.body.appendChild(newContent)
    // 延迟关闭 Time =0 不关闭
    if (Time > 0)
        setTimeout(() => {
            document.querySelector(`.my-message${id}`).remove()
        }, Time)
}
